export default "__VITE_ASSET__CWzdz_UI__"